/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAgentsRequest} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agents_messages.pb'
import {GetAgentsResponse} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agents_messages.pb'


export const getAgents = (request: GetAgentsRequest, options?: CashRequestOptions) => post<GetAgentsRequest, GetAgentsResponse>("/cash-app/agent-core/get-agents", request, {...options, rejectOnError: true })